import { StrictMode } from "react";
import ReactDOM from "react-dom";
import { useEffect } from "react";

import VideoComp from "../videoComp/videoComp";
import ShopComp from "../shopComp/shopComp";
import ImgComp from "../imgComp/imgComp";
import Navigation from "../navigation/navigation";
//ASSETS
import princess from "../../videos/princess.mp4";

import img1 from "../../images/shopComp/comp1/img1.webp";
import img2 from "../../images/shopComp/comp1/img2.webp";
import img3 from "../../images/shopComp/comp1/img3.webp";
import img4 from "../../images/shopComp/comp1/img4.webp";

import Img_1 from "../../images/imgComp/imgComp1.webp";

import imgBg1 from "./images/bgs/princess.webp";

import {
  Link,
  DirectLink,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller
} from "react-scroll";

export default function FirstComp() {
  window.scrollTo({
    top: 0
    //  behavior: "smooth"
  });
  useEffect(() => {
    scroll.scrollToTop();
  });

  return (
    <>
      {/* <div className="demo allow-scroll"> */}
      {/* <Navigation /> */}
      <VideoComp
        id={1}
        header={"Detaliile care definesc rafinamentul"}
        idHeader={"the princess"}
        videoBg={<img className="img-1" src={imgBg1} />}
        text={
          <>
            <p>
              A doua cea mai îndrăgită formă a diamantului,{" "}
              <b>tăietura Princess</b>, aduce bijuteriilor un aer modern și
              elegant.
            </p>

            <p>
              Când sunt prinse în montura cerceilor, pandantivelor sau
              brățărilor, diamantele cu tăietura Princess arată spectaculos.
            </p>
          </>
        }
        vidLink={princess}
        href={
          "https://www.teilor.com/diamond-platinum-engagement-ring-with-1-51ct-diamond-and-0-33ct-diamonds-118519.html"
        }
        buttonText={"View the ring"}
      />
      <ShopComp
        ring_1={img1}
        href_1={
          "https://www.teilor.ro/inel-de-logodna-din-aur-alb-de-18k-cu-diamant-de-0-475ct-si-diamante-de-0-16ct-103156.html"
        }
        ring_2={img2}
        href_2={
          "https://www.teilor.ro/pandant-din-aur-alb-de-18k-cu-diamante-de-0-4ct-104421.html"
        }
        ring_3={img3}
        href_3={
          "https://www.teilor.ro/cercei-din-aur-alb-de-18k-cu-diamante-de-0-74ct-110779.html"
        }
        ring_4={img4}
        href_4={
          "https://www.teilor.ro/inel-de-logodna-din-aur-alb-de-18k-cu-diamante-de-0-37ct-103954.html"
        }
        // mainLink={"https://www.teilor.ro/perpetual-love.html"}
      />
      <ImgComp
        img={Img_1}
        // header={
        //   <>
        //     DRESS HOW YOU WANT TO BE ADDRESSED. <br />
        //     <span>TREAT YOURSELF.</span>
        //     <br /> RING YOURSELF.
        //   </>
        // }
        mainLink={"https://www.teilor.com/perpetual-love.html"}
        rightText1={<span style={{ color: "#B94700" }}>Independentă</span>}
        rightText2={<span style={{ color: "#969696" }}>Cochetă</span>}
        leftText1={<span style={{ color: "#484848" }}>Romantică</span>}
        leftText2={<span style={{ color: "#D00717" }}>Luxuriantă</span>}
      />
      {/* </div> */}
    </>
  );
}
